export enum POStatus {
    To_Join = 1,
    Joined = 2,
    Fizzled = 3,
    Ended = 4,
}

export const POStatusLabel: { [key in POStatus]: string } = {
    [POStatus.To_Join]: "To Join",
    [POStatus.Joined]: "Joined",
    [POStatus.Fizzled]: "Fizzled",
    [POStatus.Ended]: "Ended",
}

export type TPO = {
    id: number;
    pO_Status: POStatus;
    requirementId: number;
    jobTitle: string;
    vendorCompanyName: string;
    endClient?: string;
    postedOn: string;
    salesManager: string
    recruiter: string;
    candidateId: number;
    candidateName: string;
    candidateEmail: string;
    bRate: number;
    sRate: number;
}

export type TPOFilter = {
    requirementId: number | null;
    salesId: number | null;
    recruiterId: number | null;
}

export const EmptyPOFilter: TPOFilter = {
    requirementId: null,
    salesId: null,
    recruiterId: null,
}
